export const NewGroupModal: string = 'NewGroupModal';
